import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-meta-form-modal',
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './meta-form-modal.component.html',
  styleUrl: './meta-form-modal.component.css'
})
export class MetaFormModalComponent {
  @Input() meta_desc: string = '';
  @Input() meta_keys: string = '';
  @Output() save = new EventEmitter<{ meta_desc: string; meta_keys: string }>();

  form: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {
    this.form = this.fb.group({
      meta_desc: [''],
      meta_keys: ['']
    });
  }

  ngOnInit() {
      setTimeout(() => {
        this.form.patchValue({
          meta_desc: this.meta_desc,
          meta_keys: this.meta_keys
        });
      });
  }

  decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  onSave() {
    const cleanMetaDesc = this.decodeHtml(this.form.value.meta_desc);
    const cleanMetaKeys = this.decodeHtml(this.form.value.meta_keys);

    this.save.emit({
      meta_desc: cleanMetaDesc,
      meta_keys: cleanMetaKeys
    });

    this.activeModal.close();
  }
}
